(() => {
  if (window.__rnSizeLinks) return;
  window.__rnSizeLinks = true;

  /* Size chart and Find your size are two separate links on the product page.
     Both open the same dialog (rn-size-finder) but on a different screen. */
  const st = document.createElement('style');
  st.textContent = 'rn-size-finder[data-mode] [data-sf-tabs]{display:none!important}' +
    '.rnmp .rnmp-size-guide-links{display:inline-flex;align-items:center;gap:18px;margin-left:auto;flex-wrap:wrap;justify-content:flex-end}' +
    '.rnmp .rnmp-size-guide-links .rnmp-size-guide-link{margin-left:0}' +
    '.rnmp .rnmp-size-guide-links [hidden]{display:none!important}';
  document.head.appendChild(st);

  const dialogOf = b => document.getElementById(b.getAttribute('data-rn-dialog-open'));
  const finderOf = b => { const d = dialogOf(b); return d ? d.querySelector('rn-size-finder') : null; };
  const quizReady = sf => !!(sf && sf.tabs && sf.tabs.hidden === false);

  /* The quiz link only appears when the quiz exists for this product (not shoes, bags, one size). */
  const reveal = () => {
    document.querySelectorAll('[data-rn-sf-open="quiz"]').forEach(b => {
      if (quizReady(finderOf(b))) b.hidden = false;
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', reveal);
  window.addEventListener('load', reveal);
  if (window.customElements && customElements.whenDefined) customElements.whenDefined('rn-size-finder').then(reveal);
  reveal();

  document.addEventListener('click', e => {
    const b = e.target.closest('[data-rn-sf-open]');
    if (!b) return;
    const sf = finderOf(b);
    if (!sf) return;
    const mode = b.getAttribute('data-rn-sf-open') === 'quiz' ? 'quiz' : 'chart';
    sf.dataset.mode = mode;
    if (quizReady(sf) && typeof sf.show === 'function') sf.show(mode);
    const h = dialogOf(b).querySelector('.rnmp-dialog__header h2');
    if (h) h.textContent = mode === 'quiz' ? 'Find your size' : 'Size chart';
  });
})();
